import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  useTheme,
} from "@mui/material";
import { useFormik } from "formik";

const EditPanduanModal = ({ open, dataEdit, onClose, onSubmit }) => {
  const theme = useTheme();

  const formik = useFormik({
    initialValues: {
      nama_sop: "",
    },
    onSubmit: (values) => {
      onSubmit(values.nama_sop);
      formik.resetForm();
      onClose();
    },
  });

  useEffect(() => {
    if (open) {
      formik.setValues({
        nama_sop: dataEdit.nama_sop || "",
      });
    } else if (!dataEdit) {
      formik.resetForm();
    }
  }, [open, dataEdit]);

  if (!open) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Panduan</DialogTitle>
      <form onSubmit={formik.handleSubmit}>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Judul Panduan"
                name="nama_sop"
                value={formik.values.nama_sop}
                onChange={formik.handleChange}
                error={
                  formik.touched.nama_sop && Boolean(formik.errors.nama_sop)
                }
                helperText={formik.touched.nama_sop && formik.errors.nama_sop}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            color="inherit"
            onClick={onClose}
            sx={{ fontSize: "14px", fontWeight: "bold", padding: "10px 20px" }}
          >
            Batal
          </Button>
          <Button
            type="submit"
            variant="contained"
            sx={{
              backgroundColor: theme.palette.secondary.light,
              color: theme.palette.background.alt,
              fontSize: "14px",
              fontWeight: "bold",
              padding: "10px 20px",
              "&:hover": {
                backgroundColor: theme.palette.secondary[500],
              },
            }}
          >
            Kirim
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default EditPanduanModal;
